module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget') ? _c('div', {
    staticClass: "box center"
  }, [(true || (_vm.signedin && !_vm.wasSignedIn)) ? _c('img', {
    staticStyle: {
      "height": "40px",
      "margin-bottom": "10px"
    },
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/svg/kortterminal-check.svg"
    }
  }) : _vm._e(), _vm._v(" "), (true || (_vm.signedin && _vm.wasSignedIn)) ? _c('p', [_vm._v("\n      Du kan strax hitta din bokning under\n      "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.myPage
    }
  }, [_vm._v("Mina sidor")]), _vm._v("\n      .\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.signedin) ? _c('CheckUpdateAddress') : _vm._e(), _vm._v(" "), _c('CollectorCheckout', {
    attrs: {
      "initial-public-token": _vm.publicToken
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3091d445"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/CollectorCheckoutConfirmation.vue
// module id = 953
// module chunks = 0